import { useEffect, useState } from "react";
import { loadDiscoLogo } from "../utils/discoAssets";

const useDiscoLogo = (companyCode) => {
  const [logoSrc, setLogoSrc] = useState("");

  useEffect(() => {
    let active = true;
    loadDiscoLogo(companyCode)
      .then((src) => {
        if (active) setLogoSrc(src);
      })
      .catch(() => {
        if (active) setLogoSrc("");
      });
    return () => {
      active = false;
    };
  }, [companyCode]);

  return logoSrc;
};

export default useDiscoLogo;
